import React, { Component } from 'react'
import PropTypes from 'prop-types'
import OpenInNew from 'material-ui/svg-icons/action/open-in-new'
import IconButton from 'material-ui/IconButton'

const iconStyle = {
  width: '25px',
  height: '25px',
  verticalAlign: 'middle',
  padding: 0
}
export default class DocLink extends Component {
  openImage = imageUrl => {
    var win = window.open(imageUrl, '_blank')
    if (win) {
      // Browser has allowed it to be opened
      win.focus()
    } else {
      // Browser has blocked it
      alert('Please allow popups for this website')
    }
  }

  render() {
    const url = this.props.url
    return (
      <IconButton style={iconStyle} onClick={this.openImage.bind(this, url)}>
        <OpenInNew color='rgb(0, 188, 212)' />
      </IconButton>
    )
  }
}

DocLink.propTypes = {
  url: PropTypes.string.isRequired
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/DocLink.js
 **/